import Axios from "axios";
import {
    SET_DOCUMENTS_TRASH_LIST,
    UNSET_DOCUMENTS_TRASH_LIST,
} from "@/store/mutation-types";

import { 
    getTrashDocumentsList,
    restoreTrashDocument,
    forceDeleteTrashDocument,
} from "@/store/api";

const state = {
    getTrashDocumentsList: [],
};

const getters = {
    getTrashDocumentsList(state) {
        return state.getTrashDocumentsList;
    },
};

const mutations = {
    [SET_DOCUMENTS_TRASH_LIST](state, data) {
        state.getTrashDocumentsList = data;
    },
    [UNSET_DOCUMENTS_TRASH_LIST](state) {
        state.getTrashDocumentsList = [];
    },
};

const actions = {
    getTrashDocumentsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {color: "primary"});
            Axios.get(getTrashDocumentsList, { params: data})
                .then(function (response) {
                    commit('SET_DOCUMENTS_TRASH_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_DOCUMENTS_TRASH_LIST')
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING")
                });
        });
    },

    restoreTrashDocument({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(restoreTrashDocument, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    forceDeleteTrashDocument({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.delete(forceDeleteTrashDocument, {
                    data: data   // 👈 THIS IS REQUIRED
                })
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

};

export default {
    state,
    getters,
    actions,
    mutations,
};
